module.exports = __webpack_public_path__ + "img/frame.d48644f2.svg";